import {ClassSessionQueries} from '../../api/class-session'

export const ClassSessionsService = {queries: ClassSessionQueries}
